import { message, Table,Button,Checkbox, Popconfirm } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { SERVER_ADDRESS } from '../../../Config/Config'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { useNavigate, } from 'react-router-dom'

const AdminList = () => {
  const [admin,setAdmin] = useState([]);
  const [loading,setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchAdmins = async()=>{
    try {
      const response = await axios.get(`${SERVER_ADDRESS}/api/viewAdmins`);
      if(response.status === 200){
        setAdmin(response.data.data)
        setLoading(false)
      }
    } catch (error) {
      if(error.response.status === 404){
        message.error({content:error.response.data.message})
      }
    }
  }

  const handleDelete = async(id)=>{
    try {
      const response = await axios.post(`${SERVER_ADDRESS}/api/deleteAdmin`,{id});
      if(response.status===200){
        setAdmin((prevAdmins) => prevAdmins.filter(admin => admin.id !== id));
      }
    } catch (error) {
      console.log(error)
      message.error({content:"Error on deleting admin"})
    }
  }
  
  const userData = JSON.parse(atob(localStorage.getItem('token').split('.')[1]));
  const userPrivelege = userData.privelege || [];
  const privelges = ["create","verification","delete","edit","subscription","suspend"] 
  useEffect(()=>{
    fetchAdmins();
    
  },[])

  const handleNavigate = async(id)=>{
    navigate(`/editAdmin/${id}`)
  } 

  const columns = [
    {
      title:"Id",
      dataIndex:"id",
      key:"id",
      sorter:(a,b)=> a.id - b.id
    },
    {
      title:"Name",
      dataIndex:"name",
      key:"name",
      sorter:(a,b)=> a.name.localeCompare(b.name)
    },
    {
      title:"Email",
      dataIndex:"email",
      key:"email",
    },
    {
      title:"Role",
      dataIndex:"role",
      key:"role",
    },
    {
      title:"Priveleges",
      dataIndex:"privelege",
      key:"privelege",
      render:(_,record)=>{
       return (
          <>
          {privelges.map((privelege)=>
          (
              <Checkbox key={privelege} checked={record.privelege.includes(privelege)} disabled >
                {privelege.charAt(0).toUpperCase()+privelege.slice(1)}
              </Checkbox>
            ))}
          </>
        )
      }
    },
    {
      title:"Option",
      dataIndex:"",
      key:"option",
      render:(_,record)=>{
        return (
          <>
          <div className='d-flex flex-row gap-2' >
          {userData.role === 'Super-Admin' && (
            <Button color='primary' onClick={()=>handleNavigate(record.id)} variant='filled' ><EditOutlined /></Button>
          )}
          {userData.role === 'Super-Admin' && (
            <Popconfirm okText='Yes' placement='top' onConfirm={()=>handleDelete(record.id)} cancelText='No' description='Are You Sure Want to delete this admin ?' >
              <Button color='danger' variant='filled'> <DeleteOutlined /> </Button>
            </Popconfirm>
          ) } 
          </div>
          </>
        )
      }
    },
  ]
  return (
    <div style={{marginTop:'4rem'}} >
        <h3 className='mb-5' >Admin / Sub-Admin List</h3>
        <Table rowKey={'id'} loading={loading} columns={columns} dataSource={admin} />
    </div>
  )
}

export default AdminList